import { useEffect, useState } from "react";
import { logDownloadPageVisit } from "../services/downloadAnalytics";
import "./DownloadApp.css";

const PLAY_STORE =
  "https://play.google.com/store/apps/details?id=com.urbanhomey.app";

const APP_STORE_WEB =
  "https://apps.apple.com/us/app/urbanhomey/id6783481499";

const APP_STORE_DEEP =
  "itms-apps://apps.apple.com/us/app/urbanhomey/id6783481499";

export default function DownloadApp() {
  const [store, setStore] = useState("");

useEffect(() => {
  console.log("==================================");
  console.log("🚀 Download Page Loaded");
  console.log("==================================");

  const ua = navigator.userAgent;

  console.log("📱 User Agent:", ua);

  const redirectPlayStore = () => {
    setTimeout(() => {
      window.location.replace(PLAY_STORE);
    }, 250);
  };

  const redirectAppStore = () => {
    setTimeout(() => {
      // Try native App Store first
      window.location.href = APP_STORE_DEEP;

      // Fallback if deep link isn't handled
      setTimeout(() => {
        window.location.replace(APP_STORE_WEB);
      }, 800);
    }, 250);
  };

  if (/Android/i.test(ua)) {
    setStore("Google Play Store");

    logDownloadPageVisit("android").catch(console.error);

    redirectPlayStore();
    return;
  }

  if (/iPhone|iPad|iPod/i.test(ua)) {
    setStore("Apple App Store");

    logDownloadPageVisit("ios").catch(console.error);

    redirectAppStore();
    return;
  }

  setStore("UrbanHomey");

  logDownloadPageVisit("desktop").catch(console.error);

  setTimeout(() => {
    window.location.replace("https://urbanhomey.com");
  }, 250);

}, []);
  return (
    <div className="download-page">
      <div className="download-card">

        <img
          src="/logo.png"
          alt="UrbanHomey"
          className="logo"
        />

        <h1>UrbanHomey</h1>

        <p>
          Find verified flats, roommates and rental homes.
        </p>

        {store && (
          <div className="redirect-box">
            Redirecting you to <strong>{store}</strong>...
          </div>
        )}

        <div className="spinner"></div>

        <div className="stores">

          <a
            href={PLAY_STORE}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/playstore.png"
              alt="Google Play"
            />
          </a>

          <a
  href={APP_STORE_WEB}
  onClick={(e) => {
    e.preventDefault();

    window.location.href = APP_STORE_DEEP;

    setTimeout(() => {
      window.location.replace(APP_STORE_WEB);
    }, 800);
  }}
>
            <img
              src="/appstore.png"
              alt="App Store"
            />
          </a>

        </div>

        <p className="small">
          If you're not redirected automatically,
          choose your store above.
        </p>

      </div>
    </div>
  );
}